import { types } from 'mobx-state-tree';


const TENURE_TYPES = {
    CONDO: 'condo',
    FREEHOLD: 'freehold',
    LEASEHOLD: 'leasehold',
};

const TenureTypeEnum = types.enumeration('TenureType', Object.values(TENURE_TYPES));

export {
    TenureTypeEnum,
};
export default TENURE_TYPES;
